import React from "react";
import { Navigate } from "react-router-dom";
import { getAuthUserString } from "../../helpers/auth_storage";


const Authmiddleware = (props:any) => {
  if (!getAuthUserString()) {
    return (
      <Navigate to={{ pathname: "/login"}} />
    );
  }
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Authmiddleware;
